import { BoldRules, ItalicRules } from '@platejs/basic-nodes'
import {
  BoldPlugin,
  ItalicPlugin,
  StrikethroughPlugin,
  UnderlinePlugin,
} from '@platejs/basic-nodes/react'

import {
  BoldLeaf,
  ItalicLeaf,
  StrikethroughLeaf,
  UnderlineLeaf,
} from './MarkLeaf'

const RichTextFieldBoldPlugin = BoldPlugin.withComponent(BoldLeaf)
const RichTextFieldItalicPlugin = ItalicPlugin.withComponent(ItalicLeaf)
const RichTextFieldUnderlinePlugin =
  UnderlinePlugin.withComponent(UnderlineLeaf)
const RichTextFieldStrikethroughPlugin =
  StrikethroughPlugin.withComponent(StrikethroughLeaf)

const RichTextFieldBasicMarksKit = [
  RichTextFieldBoldPlugin,
  RichTextFieldItalicPlugin,
  RichTextFieldUnderlinePlugin,
  RichTextFieldStrikethroughPlugin,
]

const createRichTextFieldBoldInputRule = BoldRules.markdown
const createRichTextFieldItalicInputRule = ItalicRules.markdown

export {
  BoldLeaf,
  ItalicLeaf,
  MarkLeaf,
  StrikethroughLeaf,
  UnderlineLeaf,
} from './MarkLeaf'
export type { MarkLeafElement, MarkLeafProps } from './MarkLeaf'
export {
  BoldToolbarButton,
  ItalicToolbarButton,
  StrikethroughToolbarButton,
  UnderlineToolbarButton,
} from './MarkToolbarButtons'
export type { MarkToolbarButtonProps } from './MarkToolbarButtons'
export {
  RichTextFieldBasicMarksKit,
  RichTextFieldBoldPlugin,
  RichTextFieldItalicPlugin,
  RichTextFieldStrikethroughPlugin,
  RichTextFieldUnderlinePlugin,
  createRichTextFieldBoldInputRule,
  createRichTextFieldItalicInputRule,
}
